import styled from "styled-components";

export const StyleImpactReport = styled.section`
  margin: 5rem 0 2rem;
  padding: 3rem 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #fff;
  color #0047af;
  
  @media screen and (min-width: 1500px){
    padding-inline: calc((100% - 1300px) / 2);
  }
  @media screen and (max-width: 1200px) {
    padding: 3rem 3rem;
  }
  @media screen and (max-width: 760px) {
    padding: 2rem 1rem;
  }
  @media screen and (max-width: 590px) {
    padding: 2rem 1rem 6rem;
  }

  div.ImpactReport__subbheading {
    color: #555;
  }

  div.ImpactReport__heading {
    span{
      font-family: "Host Grotesk";
    }  

    font-size: 3rem;
    font-weight: 600;
    color: #0047AF;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    @media screen and (max-width: 1200px) {
      font-size: 2.5rem;
    }
    @media screen and (max-width: 590px) {
      font-size: 2rem;
      width: 100%;
    }

    img {
      display: block;
      align-self: start;
      margin-left: 12.5rem;
      @media screen and (max-width: 1200px) {
        margin-left: 7rem;
      }
      @media screen and (max-width: 590px) {
        margin-left: 5rem;
      }
      @media screen and (max-width: 450px) {
        margin-left: 4rem;
      }
    }
    div {
      font-size: 1rem;
      color: #000;
      line-height: 0.95;
      font-weight: 500;
      margin-top: 0.5rem;
      @media screen and (max-width: 1200px) {
        font-size: 0.9rem;
      }
      @media screen and (max-width: 590px) {
        font-size: 0.8rem;
      }
    }
  }
  div.sectionReport__1 {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 1.5rem;
    column-gap: 1.5rem;
    width: 100%;
    @media screen and (max-width: 850px) {
      grid-template-columns: repeat(2, auto);
      justify-content: space-evenly;
    }
    @media screen and (max-width: 590px) {
      grid-template-columns: repeat(1, auto);
      justify-content: space-evenly;
      grid-gap: 0;
      margin-top: 2rem;
    }

    div.subSectionReport__1,
    div.subSectionReport__2,
    div.subSectionReport__3,
    div.subSectionReport__4,
    div.subSectionReport__5,
    div.subSectionReport__6 {
      width: 23rem;
      height: 20rem;
      padding-block:1rem;
      box-sizing:content-box;
      box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px,
        rgba(17, 17, 26, 0.05) 0px 8px 32px;
      margin: 2rem 0;
      @media screen and (max-width: 1200px) {
        height: 20rem;
        width: 19rem;
      }
      @media screen and (max-width: 1050px) {
        height: 18rem;
        width: 17rem;
      }
      @media screen and (max-width: 970px) {
        height: 16rem;
        width: 15rem;
      }
      @media screen and (max-width: 850px) {
        height: 19rem;
        width: 17rem;
      }
      @media screen and (max-width: 650px) {
        height: 16rem;
        width: 15rem;
      }
      @media screen and (max-width: 590px) {
        height: 18rem;
        width: 19rem;
        margin: 1rem 0;
      }
      @media screen and (max-width: 416px) {
        height: 16rem;
        width: 15rem;
        margin: 1rem 0;
      }
      div.subSectionReport__icon {
        padding: 1rem 3rem 2rem 3rem;
        @media screen and (max-width: 1200px) {
          padding: 1rem 2rem 2rem 2rem;
        }
        @media screen and (max-width: 850px) {
          padding: 1rem 2rem 2rem 2rem;
        }
        @media screen and (max-width: 590px) {
          padding: 1rem 1rem 2rem 1rem;
        }
        img {
          height: 3.5rem;
          width: auto;
          @media screen and (max-width: 1200px) {
            height: 2.7rem;
          }
          @media screen and (max-width: 970px) {
            height: 2rem;
          }
          @media screen and (max-width: 590px) {
            height: 3rem;
          }
          @media screen and (max-width: 416px) {
            height: 1.5rem;
          }
        }
        div.subSectionReport__figure {
          font-family: "Host Grotesk";
          padding-top: 1rem;
          font-size: 1.5rem;
          font-weight: 500;
          @media screen and (max-width: 1200px) {
            font-size: 1.3rem;
          }
          @media screen and (max-width: 590px) {
            font-size: 1.3rem;
          }
          
          // img {
          //   height: 1.7rem;
          //   width: auto;
          //   @media screen and (max-width: 1200px) {
          //     height: 1.5rem;
          //   }
          //   @media screen and (max-width: 970px) {
          //     height: 1.1rem;
          //   }
          //   @media screen and (max-width: 870px) {
          //     height: 1.5rem;
          //   }
          //   @media screen and (max-width: 590px) {
          //     height: 2rem;
          //     width: auto;
          //   }
          //   @media screen and (max-width: 416px) {
          //     height: 1.5rem;
          //     width: auto;
          //   }
          // }
        }
      }

      div.subSectionReport__text {
        color: #555;
        line-height: 1.6;
        font-size: 1.2rem;
        padding: 0 3rem 2rem 3rem;
        justify-self: center;
        align-self: center;
        height: 8rem;
        @media screen and (max-width: 1200px) {
          font-size: 1.1rem;
          line-height: 1.4;
          padding: 0 2rem 2rem 2rem;
          height: 7rem;
          margin-bottom: 2rem;
        }
        @media screen and (max-width: 970px) {
          font-size: 1rem;
          line-height: 1.2;
          padding: 0 2rem 2rem 2rem;
          height: 7rem;
          margin-bottom: 2rem;
        }
        @media screen and (max-width: 870px) {
          font-size: 1.2rem;
          padding: 0 2rem 2rem 2rem;
          height: 7rem;
          margin-bottom: 2rem;
        }
        @media screen and (max-width: 650px) {
          font-size: 0.9rem;
          padding: 0 1rem 2rem 1rem;
          height: 7rem;
          margin-bottom: 2rem;
        }
        @media screen and (max-width: 590px) {
          font-size: 1.15rem;
          padding: 0 1rem 2rem 1rem;
          height: 7rem;
          margin-bottom: 2rem;
        }
        @media screen and (max-width: 416px) {
          font-size: 1rem;
          padding: 0 1rem 2rem 1rem;
          height: 7rem;
          margin-bottom: 2rem;
        }
      }
    }
  }
`;
